import balanceApi from "@/api/balance";

const state = {
    isLoading: false,
    isMore: null,
    nextPage: 1,
    balance: null,
    transactions: null,
}


export const mutationTypes = {
    setIsLoading: '[balance] setIsLoading',
    setIsMore: '[balance] setIsMore',
    setNextPage: '[balance] setNextPage',
    setBalance: '[balance] setBalance',
    appendTransactions: '[balance] appendTransactions',
    clearTransactions: '[balance] clearTransactions',
}

export const actionTypes = {
    getBalance: '[balance] getBalance',
    getTransactions: '[balance] getTransactions',
}

export const getterTypes = {
    balance: '[balance] balance',
    transactions: '[balance] transactions',
    isLoading: '[balance] isLoading',
    isMore: '[balance] isMore'
}

const getters = {
    [getterTypes.balance]: state => {
        return state.balance
    },
    [getterTypes.transactions]: state => {
        return state.transactions
    },
    [getterTypes.isLoading]: state => {
        return state.isLoading
    },
    [getterTypes.isMore]: state => {
        return state.isMore
    }
}

const mutations = {
    [mutationTypes.setBalance](state, value){
        state.balance = value
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    },
    [mutationTypes.setIsMore](state, value){
        state.isMore = value
    },
    [mutationTypes.setNextPage](state, value){
        state.nextPage = value
    },
    [mutationTypes.clearTransactions](state){
        state.transactions = null
        state.nextPage = 1
        state.isMore = null
    },
    [mutationTypes.appendTransactions](state, transactions) {
        if (state.transactions === null){
            const arrProxy = new Proxy(transactions, {
              get(target, prop) {
                if (prop === 'push') {
                  return (...args) => {
                    console.log(...args);
                    return target[prop](...args);
                  };
                }
                return target[prop];
              }
            });
            state.transactions = arrProxy
        } else {
            transactions.forEach((obj) => {
                const found = state.transactions.find((element) => element.id === obj.id);
                if (!found){
                    state.transactions.push(obj)
                }
            })
        }
    },
}

const actions = {
    [actionTypes.getBalance](context) {
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
            balanceApi
                .getBalance()
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.setBalance, response.data['results'])
                    context.commit(mutationTypes.setIsLoading, false)

                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
    [actionTypes.getTransactions](context) {
        context.commit(mutationTypes.setIsLoading, true)
        let credentials = {}
        if (state.nextPage){
            credentials.page = state.nextPage
        }
        return new Promise(resolve => {
            balanceApi
                .getTransactions(credentials)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.appendTransactions, response.data['results'])
                    context.commit(mutationTypes.setIsLoading, false)

                    if (response.data['next']){
                        context.commit(mutationTypes.setIsMore, true)
                        const url = new URL(response.data['next']);
                        const urlParams = new URLSearchParams(url.search);
                        const nextPage = parseInt(urlParams.get('page'))
                        context.commit(mutationTypes.setNextPage, nextPage)
                        console.log('Next page:', nextPage)
                    } else {
                        context.commit(mutationTypes.setNextPage, null)
                        context.commit(mutationTypes.setIsMore, false)
                    }

                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}